/**
 * Idle session timeout helpers. Activity resets the idle clock; when the limit
 * elapses the app signs the user out so an abandoned browser does not keep an
 * education-record session open indefinitely.
 */

const STORAGE_KEY = "vetnebula_last_activity_at";

/** Default 30 minutes — common higher-ed idle expectation. Set env to 0 to disable. */
export function getIdleTimeoutMs(): number {
  const raw = process.env.REACT_APP_IDLE_TIMEOUT_MINUTES;
  if (raw === undefined || raw === "") {
    return 30 * 60 * 1000;
  }
  const minutes = Number(raw);
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return 0;
  }
  return minutes * 60 * 1000;
}

export function touchSessionActivity(now = Date.now()): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(now));
  } catch {
    // Private mode / blocked storage — idle guard still uses in-memory clock.
  }
}

export function readLastActivityAt(fallback = Date.now()): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? Number(raw) : NaN;
    return Number.isFinite(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function clearSessionActivity(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function isIdleExpired(
  timeoutMs: number,
  now = Date.now(),
  lastActivityAt = readLastActivityAt(now),
): boolean {
  if (timeoutMs <= 0) return false;
  return now - lastActivityAt >= timeoutMs;
}
